import React from 'react'

import FullPageMessage from '../../../components/presentation/FullPageMessage'

const SuccessfullyExecutedServiceOrderPage = () => (
  <FullPageMessage
    title="Atividade respondida com sucesso!"
    description="Obrigado por responder essa atividade. As respostas já foram enviadas com sucess!"
  />
)

export default SuccessfullyExecutedServiceOrderPage
